// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['styled-components'], styled=>{
    if (typeof styled.default!='function')
        return styled;
    const E = styled.default;
    E.css = styled.css;
    E.useTheme = styled.useTheme;
    E.createGlobalStyle = styled.createGlobalStyle;
    E.keyframes = styled.keyframes;
    return E;
});
